import RegisterForm from './components/RegisterForm'
import { Link } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import { useState } from 'react'

export default function Register() {
  const [googleLoading, setGoogleLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleGoogleSignUp = async () => {
    setGoogleLoading(true)
    setError(null)
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/auth/callback` },
    })
    if (error) {
      setError(error.message)
      setGoogleLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex">

      {/* Left Panel — hidden on mobile */}
      <div className="hidden lg:flex w-1/2 bg-gradient-to-br from-green-950 to-black flex-col justify-center px-16 border-r border-white/10">
        <div className="mb-8">
          <Link to="/" className="flex items-center gap-3 mb-16">
            <img src="/Mufulira_Wanderers_logo.png" alt="Mufulira Wanderers" className="w-8 h-8 object-contain" />
            <span className="font-black tracking-widest uppercase text-lg text-white">MWFC</span>
          </Link>
          <h1 className="text-5xl font-black uppercase leading-none tracking-tight mb-6 text-white"> 
          <span className="block">Join The</span> 
          <span className="block">Mufulira Wanderers</span> 
          <span className="block">Supporters Society</span> 
          <span className="block text-green-500">Community</span> 
          </h1>
          <p className="text-gray-400 leading-relaxed max-w-sm">
            Register as an official supporter and get your digital membership card, chapter access, and real-time club updates.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {[
            'Unique membership ID generated instantly',
            'Digital membership card with QR code',
            'Access to your regional chapter',
            'Welfare and community support access',
          ].map((item) => (
            <div key={item} className="flex items-center gap-3">
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full" />
              <span className="text-gray-400 text-sm">{item}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel - Form */}
      <div className="flex-1 flex flex-col justify-center px-4 sm:px-8 lg:px-16 py-10 lg:py-16 bg-white dark:bg-black">
        <div className="max-w-md w-full mx-auto">

          {/* Mobile logo */}
          <div className="flex lg:hidden items-center gap-3 mb-8">
            <img src="/Mufulira_Wanderers_logo.png" alt="Mufulira Wanderers" className="w-8 h-8 object-contain" />
            <span className="font-black text-gray-900 dark:text-white tracking-widest uppercase">MWFC</span>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl sm:text-3xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
              Create Account
            </h2>
            <p className="text-gray-500 text-sm">Fill in your details to become an official member</p>
          </div>

          {error && (
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50 text-red-600 dark:text-red-400 px-4 py-3 text-sm mb-4">
              {error}
            </div>
          )}

          <button
            onClick={handleGoogleSignUp}
            disabled={googleLoading}
            className="w-full flex items-center justify-center gap-3 border border-gray-200 dark:border-white/10 hover:border-gray-300 dark:hover:border-white/30 text-gray-700 dark:text-white bg-white dark:bg-transparent py-3 font-bold uppercase tracking-widest text-sm transition-colors disabled:opacity-50 mb-6"
          >
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {googleLoading ? 'Redirecting...' : 'Sign Up with Google'}
          </button>

          <div className="flex items-center gap-4 mb-6">
            <div className="flex-1 h-px bg-gray-200 dark:bg-white/10" />
            <span className="text-gray-400 text-xs uppercase tracking-widest">or register manually</span>
            <div className="flex-1 h-px bg-gray-200 dark:bg-white/10" />
          </div>

          <RegisterForm />

          <p className="text-center text-gray-500 text-sm mt-6">
            Already registered?{' '}
            <Link to="/login" className="text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300 font-semibold">
              Sign in here
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}